const kb_heissgetraenke = [
	{
		id: 1,
		title: "Café Crema",
		price: "2.50",
	},
	{
		id: 2,
		title: "Cappuccino",
		price: "3.10",
	},
	{
		id: 3,
		title: "Cappuccino mit Sahne",
		price: "3.50",
	},
	{
		id: 4,
		title: "Milchkaffee",
		price: "3.50",
	},
	{
		id: 5,
		title: "Latte Macchiato (Sirup +0,30€)",
		description: "Vanille, Caramel, Haselnuss, Lebkuchen, Zimt, Kokos",
		price: "3.60",
	},
	{
		id: 6,
		title: "Espresso",
		price: "2.20",
	},
	{
		id: 7,
		title: "Heiße Schokolade",
		price: "3.50",
	},
	{
		id: 8,
		title: "Heiße Schokolade mit Sahne",
		price: "3.90",
	},
	{
		id: 9,
		title: "Tee",
		description:
			"Darjeeling, Grüner Tee, Waldbeerentee, Roibusch Tee, Ayurveda-Kräutertee, Pfefferminztee, Kamillentee",
		price: "3.00",
	},
	{
		id: 10,
		title: "Chai Latte",
		description: "Schwarzer Tee mit Gewürzen und Milch",
		price: "3,60",
	},
	{
		id: 11,
		title: "Schokoccino",
		description: "Heiße Schokolade trifft auf köstlichen Cappuccino",
		price: "3.60",
	},
	{
		id: 12,
		title: "Cappuccino-Brûlée",
		description: "karamellisierter Cappuccino",
		price: "3.60",
	},
	{
		id: 13,
		title: "Goldene Milch (gibt´s auch kalt)",
		description: "Kurkuma, Kardamom, Zimt, Ingwer, aufgeschäumte Milch",
		price: "3.90",
	},
	{
		id: 14,
		title: "Pink Latte (gibt´s auch kalt)",
		description: "Rote Beete, Gewürze, aufgeschäumte Milch",
		price: "3.90",
	},
	{
		id: 14,
		title: "Café Capa",
		description: "Cremiger Kaffeegenuss, mit Likör gepimpt, Zimt und Orange",
		price: "4.50",
	},
	{
		id: 14,
		title: "Bombardino",
		description: "Cremiger Kaffeegenuss, mit Eierlikör und Milchschaum",
		price: "4.50",
	},
	{
		id: 14,
		title: "Irish Coffee",
		description: "Irischer Whiskey trifft auf heißen Kaffee und Sahnehäubchen",
		price: "4.90",
	},
	{
		id: 14,
		title: "Schoko-Blanco",
		description: "Heiße, weiße Schokolade",
		price: "3.80",
	},
	{
		id: 14,
		title: "Schoko-Minto",
		description: "Heiße, dunkle Schokolade mit Minze",
		price: "4.10",
	},
	{
		id: 15,
		title: "Heiße Inge",
		description: "Ingwer-Zitronen-Drink mit Pfefferminze",
		price: "4.90",
	},
	{
		id: 16,
		title: "Apfelzauber",
		description: "Heißer Apfel-Drink mit hausgemachter Gewürzbutter",
		price: "3.90",
	},
	{
		id: 15,
		title: "Apfel Spritz",
		description: "Perlender Secco mit Bratapfellikör 0,1l",
		price: "4.80",
	},
];

export default kb_heissgetraenke;
